export default {
  frontImage: 'تصویر جلو',
  backImage: 'تصویر پشت',
  healthCare: 'کارت سلامت',
  driverFleetSmartCard: 'کارت هوشمند راننده',
  navyFleetSmartCard: 'کارت هوشمند ناوگان',
  certificate: 'گواهینامه',
  vehicleIdentificationCard: 'کارت شناسایی وسیله نقلیه',
  nationalCard: 'کارت ملی',
  cardNumber: 'شماره کارت',
  approvedSuccessfully: 'با موفقیت تایید شد'
}
